import { render, staticRenderFns } from "./PrototypeModal1.vue?vue&type=template&id=74574688"
import script from "./PrototypeModal1.vue?vue&type=script&lang=js"
export * from "./PrototypeModal1.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports